import React from 'react';
import "./TermsAndConditions.css";
import {Helmet} from "react-helmet";
import {DanishTaC} from "./DanishTaC";
import {EnglishTaC} from "./EnglishTaC";

function TermsAndConditions() {
    const initialLang = React.useMemo(
        () => (navigator.language || '').toLowerCase().startsWith('en') ? 'en' : 'da',
        []
    );
    const [lang, setLang] = React.useState<'da' | 'en'>(initialLang);

    const labelText = lang === 'da' ? 'Sprog' : 'Language';

    return (
        <>
            <Helmet>
                <meta name="robots" content="noindex, nofollow"/>
            </Helmet>

            <div className="tac-lang-select container">
                <label>
                    {labelText}:{' '}
                    <select
                        value={lang}
                        onChange={e => setLang(e.target.value as 'da' | 'en')}
                    >
                        <option value="da">Dansk</option>
                        <option value="en">English</option>
                    </select>
                </label>
            </div>

            {lang === 'en' ? (
                <EnglishTaC />
            ) : lang === 'da' ? (
                <DanishTaC/>
            ) : <EnglishTaC />}
        </>
    );
}

export default TermsAndConditions;
